import React from 'react';
import { Map, Layers, PenTool, BarChart3 } from 'lucide-react';

const MapNavigation = ({ activeModule, onModuleChange }) => {
  const tabs = [
    { id: 'overview', label: 'Vista General', icon: Map, color: 'text-green-600 bg-green-50' },
    { id: 'layers', label: 'Capas de Datos', icon: Layers, color: 'text-blue-600 bg-blue-50' },
    { id: 'drawing', label: 'Dibujar y Medir', icon: PenTool, color: 'text-amber-600 bg-amber-50' },
    { id: 'analysis', label: 'Análisis Geográfico', icon: BarChart3, color: 'text-purple-600 bg-purple-50' }
  ];

  return (
    <nav className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex space-x-8 overflow-x-auto py-3">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeModule === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => onModuleChange(tab.id)}
                className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all shrink-0 ${
                  isActive
                    ? `${tab.color} border border-current shadow-sm`
                    : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                <Icon className="w-4 h-4" />
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default MapNavigation;
